import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useUserStore = defineStore(
    'user',
    () => {
        const info = ref<any>('');

        const setUserInfo = (userInfo: any) => {
            info.value = userInfo;
            
        };
        const clearUserInfo = () => {
            info.value = ''
        }
        const updateDays = (days: number | string) => {
            info.value.days = days;
        }

        const updateBindWx = (wxInfo: any = {}) => {
            info.value.wx_nickname = wxInfo.wx_nickname;
            info.value.wx_bind_time = wxInfo.wx_bind_time;
            info.value.avatar = wxInfo.avatar
        }
        

        return {
            info,
            setUserInfo,
            clearUserInfo,
            updateBindWx,
            updateDays
        };
    },
    { persist: true }
);
